import { lazy } from 'react'

export const HelpCalmCravings = lazy(() => import('./HelpCalmCravings'))
